import { faArrowRight } from '@fortawesome/pro-regular-svg-icons'
import { Flex } from '@mantine/core'
import React from 'react'

import { type CoreInquiry } from '@flecto/types'
import { Icon, TextDate } from '@flecto/ui'

export type CellDatesProps = {
  inquiry?: CoreInquiry
}

export function CellDates({ inquiry }: CellDatesProps) {
  return (
    <Flex align='center' gap='sm'>
      <TextDate date={inquiry?.start_at ?? ''} variant='datetime-brief' />
      <Icon icon={faArrowRight} color='gray.7' />
      <TextDate date={inquiry?.end_at ?? ''} variant='datetime-brief' />
    </Flex>
  )
}
